




















import { Component, Prop } from "vue-property-decorator";
import { BModal } from "bootstrap-vue/src/components/modal";
import AbortButton from "@/components/Button/AbortButton.vue";
import SaveButton from "@/components/Button/SaveButton.vue";
import ModalMixin from "@/mixins/ModalMixin";
import { mixins } from "vue-class-component";
import i18n from "@/i18n";

@Component({
  components: { BModal, SaveButton, AbortButton },
})
export default class DeleteModal extends mixins(ModalMixin) {
  public name = "DeleteModal";

  @Prop()
  public title!: string;

  @Prop()
  public question!: string;

  @Prop({ type: String, default: () => i18n.t("general.yes") })
  public saveBtnLabel!: string;

  @Prop({ type: String, default: () => i18n.t("general.yes") })
  public hardSaveBtnLabel!: string;

  @Prop({ type: String, default: () => i18n.t("general.no") })
  public cancelBtnLabel!: string;

  @Prop({ type: Function, default: () => null })
  public deleteAction!: () => void;

  @Prop({ type: Function, default: () => null })
  public deletePermanentlyAction!: () => void;

  @Prop({ type: String, default: () => "delete-modal-id" })
  public modalId!: string;

  private onDelete(): void {
    this.deleteAction();
    this.$bvModal.hide(this.modalId);
  }

  private onDeletePermanently(): void {
    this.deletePermanentlyAction();
    this.$bvModal.hide(this.modalId);
  }
}
